/* Enlarge the subject inside white catalogue canvases without cropping bottle details.
   Photos with a non-white border, or unreadable image pixels, keep their original fit. */
(() => {
  const selector = '.collection--main-grid .card__media img';
  const mobile = matchMedia('(max-width: 749px)');
  const measured = new WeakMap();
  function bounds(img) {
    if (measured.has(img)) return measured.get(img);
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 96;
    const ctx = canvas.getContext('2d', { willReadFrequently: true });
    if (!ctx) return null;
    try {
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, 96, 96); ctx.drawImage(img, 0, 0, 96, 96);
      const pixels = ctx.getImageData(0, 0, 96, 96).data;
      const dark = (x, y) => { const i = (y * 96 + x) * 4; return Math.min(pixels[i], pixels[i+1], pixels[i+2]) < 235; };
      let edge = 0;
      for (let i=0; i<96; i++) edge += Number(dark(i,0))+Number(dark(i,95))+Number(dark(0,i))+Number(dark(95,i));
      if (edge > 16) { measured.set(img,null); return null; }
      let left=96,top=96,right=0,bottom=0;
      for(let y=0;y<96;y++) for(let x=0;x<96;x++) if(dark(x,y)) { left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y); }
      const b={x:left/96,y:top/96,w:(right-left+1)/96,h:(bottom-top+1)/96};
      const result=b.w>.1&&b.w<.7&&b.h>.3 ? b : null;
      measured.set(img,result);return result;
    } catch { measured.set(img,null);return null; }
  }
  function fit(img) {
    img.style.removeProperty('transform');
    if(!mobile.matches || !img.complete || !img.naturalWidth) return;
    const b=bounds(img);if(!b)return;
    const w=img.clientWidth,h=img.clientHeight;
    if(!w||!h)return;
    const unit=Math.min(w/img.naturalWidth,h/img.naturalHeight);
    const pw=unit*img.naturalWidth,ph=unit*img.naturalHeight;
    const scale=Math.min(1.75,w*.9/(b.w*pw),h*.9/(b.h*ph));
    if(scale<=1.03)return;
    const tx=-(b.x+b.w/2-.5)*pw*scale,ty=-(b.y+b.h/2-.5)*ph*scale;
    img.style.transform=`translate(${tx}px,${ty}px) scale(${scale})`;
    img.dataset.dibaoFramed='true';
  }
  const observer=new ResizeObserver(entries=>entries.forEach(e=>fit(e.target)));
  function init(root=document) {
    root.querySelectorAll(selector).forEach(img=>{
      if(img.dataset.dibaoFrameReady)return;
      img.dataset.dibaoFrameReady='true';
      img.addEventListener('load',()=>{measured.delete(img);fit(img)});
      observer.observe(img);fit(img);
    });
  }
  document.addEventListener('DOMContentLoaded',()=>init());
  document.addEventListener('shopify:section:load',e=>init(e.target));
  mobile.addEventListener('change',()=>document.querySelectorAll(selector).forEach(fit));
})();
